module.exports = __webpack_public_path__ + "static/img/jiminny-logo-white-long-2x.8bd1320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiminny-logo-white-long-2x.png
// module id = Glt7
// module chunks = 1